/* eslint-disable ember/no-classic-components, ember/no-computed-properties-in-native-classes, ember/require-tagless-components */
import Component from '@ember/component';
import GradingMethod from '@linc-technologies/linced-common/enums/grading-method';
import { getGradeForDisplay } from '@linc-technologies/linced-common/utils/grades';
import { action, computed } from '@ember/object';

export default class AssessmentGrade extends Component {
  GradingMethod = GradingMethod;

  @computed('grade.assessorType')
  get isAwardedByLearner() {
    return this.grade.assessorType === 1;
  }

  @action
  getAwarded(module, grade) {
    return getGradeForDisplay(module, grade);
  }
}
